import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FamilyTreeService } from '../services/family-tree.service';
import { Select, Store } from '@ngxs/store';
import { FamilyTreeState } from 'src/app/state/family-tree/family-tree.state';
import { Observable } from 'rxjs';
import { IFamilyTreeTrail } from 'src/app/common/models/IFamilyTreeTrail';
import { MatDialog } from '@angular/material/dialog';
import { TrailHistoryComponent } from '../trail-history/trail-history.component';
import { SetFamilyTreeNodeData } from 'src/app/state/family-tree/family-tree.actions';
import { Router } from '@angular/router';


@Component({
    selector: 'app-horizontal-trial-breadcrumb-menu',
    templateUrl: './horizontal-trial-breadcrumb-menu.component.html',
    styleUrls: ['./horizontal-trial-breadcrumb-menu.component.scss']
})
export class HorizontalTrialBreadcrumbMenuComponent implements OnInit, OnDestroy {

    @Select(FamilyTreeState) familyTrailData$: Observable<any>;
    @Select(FamilyTreeState.getFamilyVisitedProfileState) familyVisitedProfile$: Observable<boolean>;
    public familyTrails: IFamilyTreeTrail[];
    public focusedTrail: IFamilyTreeTrail;
    private subscribe;

    constructor(private router: Router,
        private store: Store,
        private familyTreeService: FamilyTreeService,
        private dialog: MatDialog,
        private cdk: ChangeDetectorRef) { }

    ngOnInit() {
        this.subscribe = this.familyTrailData$.subscribe(data => {
            if (data) {
                this.familyTrails = [];
                this.cdk.markForCheck();
                setTimeout(() => {
                    this.familyTrails = data?.familyTrail;
                    this.focusedTrail = data?.focusedTrail;
                });

            }
        });
    }

    ngOnDestroy(): void {
        this.familyTrails = [];
        if (this.subscribe) {
            this.subscribe.unsubscribe();
        }
    }

    ionViewDidLeave(): void {
        this.familyTrails = [];
        if (this.subscribe) {
            this.subscribe.unsubscribe();
        }
    }

    navigateBackToTree(index) {
        this.familyTreeService.removeFromFamilyTree(index);
    }

    trailHistoryOpen() {
        this.dialog.open(TrailHistoryComponent, {
            height: '700px',
            width: '95vw'
        });
    }

    updateNode(dataIN) {
        this.familyTrails = [];
        this.store.dispatch(new SetFamilyTreeNodeData(
            { rowData: JSON.stringify(dataIN), type: 'edit', from: 'boxEdit' }
        )).subscribe(() => {
            this.router.navigate(['/profile/create-update-family-members']);
        });
    }
}
